export default __webpack_public_path__ + "static/media/UFO-im-Weltraum.24b21867.webp";